/*eslint-disable*/
import React, { Component } from 'react';
import { reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import 'react-credit-cards/es/styles-compiled.css';
import { completedEvent } from "../../../../redux/actions/action_postEvent";
import { green } from '../../../../utils/constants';

const FormName = 'postevent';
class CompleteEvent extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    const {
      handleSubmit,
      eventId
    } = this.props;

    this.props.dispatch(completedEvent(eventId));

    return (
      <div style={{ marginTop: '1%' }} sm={5}>
        <form onSubmit={handleSubmit} className="form-horizontal">
          {
            (<div><span style={{ paddingLeft: '15px', color: green, fontSize: '16px' }}>
              <p className="fa fa-check" />&nbsp;&nbsp;Post Management is complete. Click previous to go back, navigate using the menu or log out to close the app.</span>
            </div>)}
        </form>
      </div>)
  }
}

CompleteEvent.propTypes = {
  handleSubmit: PropTypes.func,
  eventId: PropTypes.number,
}

function mapStateToProps(state, ownProps) {
  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const eventId = selector(state, 'eventId')
  return {
    eventId
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    completedEvent
  }, dispatch);
}
export default reduxForm({
  form: FormName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(CompleteEvent))


// WEBPACK FOOTER //
// ./src/containers/postevent/components/fees/completedevent.js